module.exports = __webpack_public_path__ + "static/media/Why_vote_gif.ab2480ce.gif";